import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgConsultHistoryGlyphSecondary from './svgs/ConsultHistoryGlyphSecondary.js';
import SvgConsultHistoryGlyph from './svgs/ConsultHistoryGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var consultHistoryGlyph = (props => useIcon(SvgConsultHistoryGlyph, SvgConsultHistoryGlyphSecondary, props));

export { consultHistoryGlyph as default };
